import axios from "axios";

// === STATE =====================================================================================
const state = {
	ready: "not-ready",
	loading: false,
	apps: [],
	enable_notification: true,
	notifications: [],
	window: {
		name: false,
		params: {}
	},
	app_parameters: {}
};


// === GETTERS =====================================================================================
const getters = {
	app: function (state) { return state; },
	app_parameters: state => { return state.app_parameters; }
};


// === ACTIONS =====================================================================================
const actions = {


	init_app: async function ({ commit, dispatch }, data) {
		dispatch("load_apps");
		try {
			if (data && data.callback) {
				data.callback();
			}
		} catch (error) {
			console.error("Error in init_app", error);
		}

		axios.get(process.env.VUE_APP_BASE_URL_PARAMETER)
			.then(function (result) {
				commit("SET_APP_PARAMETERS", result.data);
			})
			.catch(function (error) {
				console.error("an error happened while retrieving app parameters", error);
			});
	},


	load_apps: function () {
		return false;
	},

	async load_lists ({ commit }, data) {

		try {
			const response = await axios.get(process.env.VUE_APP_API_BASE_URL + "api/list");
			
			const data_lists = response.data.content;
			
			const lists = {};

			lists.segments = data_lists.segments;
			lists.statuts = data_lists.statuts;
			lists.templates = data_lists.templates;
			lists.etude_types = data_lists.etudeTypes;
			lists.contribution_types = data_lists.contributionTypes;
			lists.years = data_lists.years;
			lists.departements = data_lists.departements;
			lists.code_evalis_list = data_lists.code_evalis_list;
			lists.contributeurs = data_lists.contributeurs;

			// put "Etude" at the beginning of the etude types list
			let etudeFound = false;
			let i = 0;
			let etude, copy;
			while(!etudeFound && i < lists.etude_types.length){
				etude = lists.etude_types[i];
				etudeFound = etude.nom == "Etude";
				if(etudeFound){
					copy = _.cloneDeep(etude);
					lists.etude_types.splice(i,1);
					lists.etude_types.unshift(copy);
				}
				i += 1;
			}
			
			// put "Etude" at the beginning of the etude types list of every segment
			for(const segment of lists.segments){
				let etudeFound = false;
				let i = 0;
				let etude, copy;
				while(!etudeFound && i < segment.etudeTypes.length){
					etude = segment.etudeTypes[i];
					etudeFound = etude.nom == "Etude";
					if(etudeFound){
						copy = _.cloneDeep(etude);
						segment.etudeTypes.splice(i,1);
						segment.etudeTypes.unshift(copy);
					}
					i += 1;
				}
			}
			
			lists.users = _.sortBy(_.map(data_lists.utilisateurs, function (user) {
				const obj = _.clone(user);
				obj.prenom = _.upperFirst(obj.prenom);
				obj.nom = _.upperCase(obj.nom);
				return obj;
			}), "nom");

			commit("SET_LISTS", { lists: lists });
			if (data && data.callback) data.callback();
		} catch (error) {
			console.error("ERROR while retrieving the cdc/list web service data", error);
		}
	},

	set_ready: function ({ commit }, data) {
		commit("SET_READY", {
			ready: data.ready
		});
	},


	set_loading: function ({ commit }, data) {
		commit("SET_LOADING", {
			loading: data.loading
		});
	},


	add_notification: function ({ commit, state }, data) {
		if (state.enable_notification) {
			commit("ADD_NOTIFICATION", { notification: data });
			setTimeout(function () {
				commit("REMOVE_NOTIFICATION", { notification: data });
			}, 5000);
		}
	},


	remove_notification: function ({ commit }, data) {
		commit("REMOVE_NOTIFICATION", { notification: data.notification });
	},


	set_window: function ({ commit }, data) {
		const o = {
			name: data.name
		};
		if (data.params) o.params = data.params;
		commit("SET_WINDOW", o);
	}


};


// === MUTATIONS =====================================================================================
const mutations = {


	SET_APPS: function (state, data) {
		state.apps = data.apps;
	},

	SET_READY: function (state, data) {
		state.ready = data.ready;
	},

	SET_APP_PARAMETERS: function (state, data) {
		state.app_parameters = data;
	},

	SET_LOADING: function (state, data) {
		state.loading = data.loading;
	},

	SET_ENABLE_NOTIFICATION: function (state, data) {
		state.enable_notification = data.enable;
	},

	ADD_NOTIFICATION: function (state, data) {
		if (!data.notification.id) data.notification.id = _.uniqueId("notification-");
		state.notifications.push(data.notification);
	},

	REMOVE_NOTIFICATION: function (state, data) {
		const index = _.indexOf(state.notifications, data.notification);
		state.notifications.splice(index, 1);
	},

	SET_WINDOW: function (state, data) {
		state.window.name = data.name;
		state.window.params = data.params;
	}

};

export default {
	state,
	getters,
	actions,
	mutations
};